"use strict";

// Copyright 2019-2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var Maybe_1 = require("../maybe/Maybe");
var TimeoutScheduler_1 = require("../scheduler/TimeoutScheduler");
var DefaultPromisedWebSocket = /** @class */function () {
  function DefaultPromisedWebSocket(webSocket) {
    this.webSocket = webSocket;
    this.callbacks = new Map();
  }
  Object.defineProperty(DefaultPromisedWebSocket.prototype, "url", {
    get: function () {
      return this.webSocket.url;
    },
    enumerable: false,
    configurable: true
  });
  DefaultPromisedWebSocket.prototype.open = function (timeoutMs) {
    return __awaiter(this, void 0, void 0, function () {
      var promise;
      var _this = this;
      return __generator(this, function (_a) {
        promise = new Promise(function (resolve, reject) {
          _this.webSocket.onclose = function (event) {
            _this.dispatchEvent(event);
          };
          _this.webSocket.onmessage = function (event) {
            _this.dispatchEvent(event);
          };
          _this.webSocket.onopen = function (event) {
            _this.dispatchEvent(event);
            resolve(event);
          };
          _this.webSocket.onerror = function (event) {
            _this.dispatchEvent(event);
            reject(event);
          };
        });
        return [2 /*return*/, this.withTimeout(promise, timeoutMs)];
      });
    });
  };
  DefaultPromisedWebSocket.prototype.close = function (timeoutMs, code, reason) {
    return __awaiter(this, void 0, void 0, function () {
      var promise;
      var _this = this;
      return __generator(this, function (_a) {
        promise = new Promise(function (resolve, reject) {
          _this.webSocket.onclose = function (event) {
            _this.dispatchEvent(event);
            resolve(event);
          };
          _this.webSocket.onerror = function (event) {
            _this.dispatchEvent(event);
            reject(event);
          };
          _this.webSocket.close(code, reason);
        });
        return [2 /*return*/, this.withTimeout(promise, timeoutMs)];
      });
    });
  };
  DefaultPromisedWebSocket.prototype.send = function (data) {
    this.webSocket.send(data);
  };
  DefaultPromisedWebSocket.prototype.onMessage = function (fn) {
    this.addEventListener('message', fn);
    return this;
  };
  DefaultPromisedWebSocket.prototype.onClose = function (fn) {
    this.addEventListener('close', fn);
    return this;
  };
  DefaultPromisedWebSocket.prototype.dispatchEvent = function (event) {
    Maybe_1.default.of(this.callbacks.get(event.type)).map(function (listeners) {
      return listeners.forEach(function (listener) {
        return listener(event);
      });
    });
    return event.defaultPrevented;
  };
  DefaultPromisedWebSocket.prototype.addEventListener = function (type, listener) {
    var _this = this;
    Maybe_1.default.of(this.callbacks.get(type)).defaulting(new Set()).map(function (listeners) {
      return listeners.add(listener);
    }).map(function (listeners) {
      return _this.callbacks.set(type, listeners);
    });
  };
  DefaultPromisedWebSocket.prototype.removeEventListener = function (type, listener) {
    Maybe_1.default.of(this.callbacks.get(type)).map(function (f) {
      return f.delete(listener);
    });
  };
  DefaultPromisedWebSocket.prototype.withTimeout = function (promise, timeoutMs) {
    return __awaiter(this, void 0, void 0, function () {
      var timeout;
      return __generator(this, function (_a) {
        timeout = new Promise(function (resolve, reject) {
          new TimeoutScheduler_1.default(timeoutMs).start(function () {
            reject(new Error('Promise timed out after ' + timeoutMs + 'ms'));
          });
        });
        return [2 /*return*/, Promise.race([promise, timeout])];
      });
    });
  };
  return DefaultPromisedWebSocket;
}();
exports.default = DefaultPromisedWebSocket;